const u = up.util;
const e = up.element;
up.Tether = class Tether {
    constructor(options) {
        var _a, _b;
        (_b = (_a = up.migrate).handleTetherOptions) === null || _b === void 0 ? void 0 : _b.call(_a, options);
        this._anchor = options.anchor;
        this._align = options.align;
        this._position = options.position;
        this._alignAxis = (this._position === 'top') || (this._position === 'bottom') ? 'horizontal' : 'vertical';
        this._viewport = up.viewport.get(this._anchor);
        this.parent = this._viewport === e.root ? document.body : this._viewport;
        this._syncOnScroll = !this._viewport.contains(this._anchor.offsetParent);
    }
    start(element) {
        this._element = element;
        this._element.style.position = 'absolute';
        this._setOffset(0, 0);
        this.sync();
        this._changeEventSubscription('on');
    }
    stop() {
        this._changeEventSubscription('off');
    }
    _changeEventSubscription(fn) {
        let doScheduleSync = this._scheduleSync.bind(this);
        up[fn](window, 'resize', doScheduleSync);
        if (this._syncOnScroll) {
            up[fn](this._viewport, 'scroll', doScheduleSync);
        }
    }
    _scheduleSync() {
        clearTimeout(this.syncTimer);
        return this.syncTimer = u.task(this.sync.bind(this));
    }
    isAlive() {
        return up.fragment.isAlive(this.parent) && up.fragment.isAlive(this._anchor);
    }
    sync() {
        const elementBox = this._element.getBoundingClientRect();
        const elementMargin = {
            top: e.styleNumber(this._element, 'margin-top'),
            right: e.styleNumber(this._element, 'margin-right'),
            bottom: e.styleNumber(this._element, 'margin-bottom'),
            left: e.styleNumber(this._element, 'margin-left')
        };
        const anchorBox = this._anchor.getBoundingClientRect();
        let left;
        let top;
        switch (this._alignAxis) {
            case 'horizontal': {
                switch (this._position) {
                    case 'top':
                        top = anchorBox.top - elementMargin.bottom - elementBox.height;
                        break;
                    case 'bottom':
                        top = anchorBox.top + anchorBox.height + elementMargin.top;
                        break;
                }
                switch (this._align) {
                    case 'left':
                        left = anchorBox.left + elementMargin.left;
                        break;
                    case 'center':
                        left = anchorBox.left + (0.5 * (anchorBox.width - elementBox.width));
                        break;
                    case 'right':
                        left = (anchorBox.left + anchorBox.width) - elementBox.width - elementMargin.right;
                        break;
                }
                break;
            }
            case 'vertical': {
                switch (this._align) {
                    case 'top':
                        top = anchorBox.top + elementMargin.top;
                        break;
                    case 'center':
                        top = anchorBox.top + (0.5 * (anchorBox.height - elementBox.height));
                        break;
                    case 'bottom':
                        top = (anchorBox.top + anchorBox.height) - elementBox.height - elementMargin.bottom;
                        break;
                }
                switch (this._position) {
                    case 'left':
                        left = anchorBox.left - elementMargin.right - elementBox.width;
                        break;
                    case 'right':
                        left = anchorBox.left + anchorBox.width + elementMargin.left;
                        break;
                }
                break;
            }
        }
        if (u.isDefined(left) || u.isDefined(top)) {
            this._moveTo(left, top);
        }
        else {
            up.fail('Invalid tether constraints: %o', this._describeConstraints());
        }
    }
    _describeConstraints() {
        return { position: this._position, align: this._align };
    }
    _moveTo(targetLeft, targetTop) {
        const elementBox = this._element.getBoundingClientRect();
        this._setOffset((targetLeft - elementBox.left) + this.offsetLeft, (targetTop - elementBox.top) + this.offsetTop);
    }
    _setOffset(left, top) {
        this.offsetLeft = left;
        this.offsetTop = top;
        e.setStyle(this._element, { left, top }, 'px');
    }
};
